<template>
  <div class="importDetail">
    <a-card :bordered="false">
      <div class="detail-top" v-if="importList.totalNumber">
        <p>
          共导入：<span>{{ importList.totalNumber }}</span>
        </p>
        <p>
          导入成功：<span>{{ importList.successNumber }}</span>
        </p>
        <p>
          导入失败：<span style="color: red"
            >{{ importList.failNumber }} ( 导入失败的名单不发送 )</span
          >
        </p>
      </div>
      <!-- 查询区域 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline" @keyup.enter.native="searchQuery">
          <a-row :gutter="24">
            <a-col :xl="10" :lg="12" :md="12" :sm="24">
              <a-form-item label="导入状态">
                <a-select v-model="queryParam.state" placeholder="请选择状态">
                  <a-select-option
                    v-for="(item, index) in stateList"
                    :value="item.value"
                    :key="index"
                  >
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <span
                style="float: left; overflow: hidden"
                class="table-page-search-submitButtons"
              >
                <a-button type="primary" @click="searchQuery" icon="search"
                  >查询</a-button
                >
                <a-button
                  type="primary"
                  @click="searchReset"
                  icon="reload"
                  style="margin-left: 8px"
                  >重置</a-button
                >
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 查询区域-END -->

      <!-- table区域-begin -->
      <div>
        <a-table
          ref="table"
          size="middle"
          bordered
          :scroll="{ x: true }"
          :rowKey="(record) => record.id"
          :columns="columns"
          :dataSource="dataSource"
          :pagination="ipagination"
          :loading="loading"
          class="j-table-force-nowrap"
          @change="handleTableChange"
        >
          <span slot="paramFormats" slot-scope="text">
            {{ text ? text.userName : '--' }}
          </span>
        </a-table>
      </div>
    </a-card>
  </div>
</template>

<script>
import '@/assets/less/TableExpand.less';
import { postTag } from '@/api/manage';
import customRender from '@/utils/customRender.js';

export default {
  name: 'ImportDetail',
  data() {
    return {
      stateList: [
        {
          name: '导入成功',
          value: 0,
        },
        {
          name: '导入失败',
          value: 1,
        },
      ],
      importList: {},
      description: '导入详情',
      loading: false,
      selectedRowKeys: [],
      selectionRows: [],
      dataSource: [],
      queryParam: {
        state: 1,
      },
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0,
      },
      // 表头
      columns: [
        {
          title: '姓名',
          align: 'center',
          dataIndex: 'paramFormats',
          scopedSlots: { customRender: 'paramFormats' },
        },
        {
          title: '手机号',
          align: 'center',
          dataIndex: 'account',
          customRender: customRender,
        },
        {
          title: '短信内容',
          align: 'center',
          dataIndex: 'content',
          // ellipsis: true,
          customRender: customRender,
        },
        {
          title: '导入状态',
          align: 'center',
          dataIndex: 'impStatus',
          customRender: (text) => {
            if (text == 0) {
              return '成功';
            } else if (text == 1) {
              return '失败';
            }
          },
        },
        {
          title: '失败原因',
          align: 'center',
          dataIndex: 'reason',
          customRender: customRender,
        },
      ],
      url: {
        list: process.env.VUE_APP_CMS_SMSBIZ + '/mgTkRecord/page',
      },
    };
  },
  // created() {
  //   this.getList();
  // },
  methods: {
    // 查询
    getList(arg) {
      let that = this;
      if (arg === 1) {
        that.ipagination.current = 1;
      }
      let params = {
        pageNo: that.ipagination.current,
        pageSize: that.ipagination.pageSize,
        impStatus: that.queryParam.state,
        impGroupId: that.importList.impGroupId,
      };
      that.loading = true;
      postTag(this.url.list, params).then((res) => {
        if (res.success) {
          that.dataSource =
            res.result && res.result.records ? res.result.records : [];
          that.loading = false;
          that.ipagination.total = res.result.total;
        } else {
          that.$message.error(res.message);
        }
      });
    },
    searchQuery() {
      this.getList(1);
    },
    //重置
    searchReset() {
      this.queryParam = {};
      if (this.$route.query.type != 4) {
        this.getList(1);
      }
    },
    onClearSelected() {
      this.selectedRowKeys = [];
      this.selectionRows = [];
    },
    //分页
    handleTableChange(pagination, filters, sorter) {
      this.onClearSelected(); //分页切换时清空表格选中
      //分页、排序、筛选变化时触发
      if (Object.keys(sorter).length > 0) {
        this.isorter.column = sorter.field;
        this.isorter.order = 'ascend' == sorter.order ? 'asc' : 'desc';
      }
      this.ipagination = pagination;
      this.getList();
    },
  },
};
</script>
<style scoped>
@import '~@assets/less/common.less';
/* .table-page-search-wrapper {
  width: 150%;
} */
.ant-card {
  height: 100%;
  overflow: auto;
}
.importDetail {
  height: 100%;
}
.detail-top p {
  margin-right: 5%;
  display: inline-block;
  color: #000;
}
</style>
